import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { Check } from "lucide-react"
import { useAppCtx } from "lib/state"
import { queryTools, cn, randoms } from "lib/utils"
import { useGenericQuery } from "lib/hooks"
import { findById, updateById } from "lib/utils/apiHelpers"
import { Form, FormButton, FormLabel, FieldGroup, InputField, RenderLayout, SelectField } from "lib/components"

export default function DisputeSetup(){

  const { dspid } = useParams()
  const [ fetchData, setFetchData ] = useState<string>()

  const { data, status, error } = useGenericQuery({ resource: "layout", qk: ["layouts"], enabled: true })
  
  // const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { _id: fetchData }, { enabled: !!fetchData })
  const { data:_Clients } = queryTools.resource.parseQueryForApi("client.findAll", {})
  // const { data:_Layouts } = queryTools.resource.parseQueryForApi("layout.findAll", {})
  // const saveFn = queryTools.resource.save(["dispute"])

  const [ dispute, setDispute ] = useState<any>()
  const [ previewLayout, setPreviewLayout ] = useState<any>(undefined)


  const getDispute = async(id:string) => await findById({ resource: "dispute", idObj: { key: "_id", value: id } })
  const updateDispute = async(id:string, data:any) => await updateById({ resource: "dispute", idObj: { key: "_id", value: id }, data })



  async function handleDisputeSave(e:any){
    e.preventDefault()
    // const formData:any = new FormData(e.target)
    // let data = Object.fromEntries(formData.entries())
    console.log(dispute)
    await updateDispute(dispute._id, dispute)
  }

  const processingOpts = [
    { value: "send", label: "Send the html + css to the Midmetrics server." },
    { value: "generate", label: "Generate the PDF here, but do not engage any of the editing modules." },
    { value: "generate+edit", label: "Generate the PDF here, and engage any editing modules that have been selected." }
  ]

  const handleInputChange = (e:any) => {
    const { name, value } = e.target
    setDispute({...dispute, [name]: value })
  }

  useEffect(() => {
    console.log(data)
    console.log(status)
    if( data && dispute?.layout && previewLayout === undefined ){
      console.log("setting default layout")
      const preview = data.find((item:any) => item.name === dispute.layout)
      if( preview ){
        setPreviewLayout(preview)
      }
    }
  },[dispute, previewLayout, data])

  useEffect(() => {
    if( dspid ){
      getDispute(dspid).then((disputeObj:any) => {
        console.log(disputeObj)
        if( disputeObj ){
          const { _id, Id, title, layout } = disputeObj
          setDispute({ _id, Id, title, layout })
        }
      })
    }
  },[dspid])

  if( !dispute ) return <></>
  return (
    <div className="w-full h-full *:text-neutral-200">
      <Form className="w-full flex flex-col justify-start items-start gap-4" onSubmit={handleDisputeSave}>

        <div className="w-full flex justify-start items-start gap-24 px-2 mt-6">
          <div className="w-6/12 flex flex-col">
            <h3 className="text-base uppercase pb-1 mb-3 border-b border-solid border-slate-700">Basics</h3>

            <FieldGroup className="w-24 mb-6" label="Numeric Id" required={true}>
              <InputField name="Id" placeholder="Id" value={dispute.Id} onChange={handleInputChange} />
            </FieldGroup>

            <FieldGroup className="w-full mb-6" label="title" required={true}>
              <InputField name="title" placeholder="Already Refunded" value={dispute.title} onChange={handleInputChange} />
            </FieldGroup>

            <FieldGroup className="w-full mb-6" label="layout" required={false}>
              <SelectField 
                name="layout" 
                placeholder="Select a layout" 
                value={previewLayout?.name || dispute.layout || ""} 
                options={[{ value: "", label: "Select a layout" }, ...( data || [] ).map((l:any) => ({ value: l.name, label: l.name }))]} 
                selectFn={(layoutName:string) => setPreviewLayout(data?.find((l:any) => l.name === layoutName) || null)}
              />
            </FieldGroup>

            <FieldGroup className="pt-5 w-[8rem]">
              <FormButton>Save Changes</FormButton>
            </FieldGroup>
          </div>

          { previewLayout !== undefined && (
            <div className="w-6/12 flex flex-col">
              <p>{previewLayout?.name}</p>
              { previewLayout?.config?.structure.length === 0 ? (
                <p>No preview available.</p>
              ):(
                <div>
                  <RenderLayout 
                    mode="wireframe" 
                    handleWireframeClick={() => null} 
                    editable={true} 
                    layout={previewLayout?.config.structure} 
                  />

                  { previewLayout?.name !== dispute.layout && (
                    <div className="w-full flex justify-end items-center mt-4">
                      <FormButton 
                        type="button"
                        onClick={() => setDispute({...dispute, layout: previewLayout?.name })}
                      >
                        Choose This Layout
                      </FormButton>
                    </div>
                  )}
                </div>
              )}

            </div>
          )}

          {/* <div className="w-6/12 flex flex-col">
            <h3 className="text-base uppercase pb-1 mb-3 border-b border-solid border-slate-700">Processing</h3>
            <p>When a request is received for this dispute, how should it be processed:</p>

            <div className="w-full flex flex-col gap-8 mt-4">

              { processingOpts.map( (opt:any) => (
                <div key={opt.value} className="w-full flex justify-start items-start gap-4">
                  <div 
                      onClick={() => setDisputeForm({...disputeForm, Processing: opt.value })}
                      className="w-5 h-5 bg-transparent border border-solid border-slate-700 flex justify-center items-center relative cursor-pointer"
                    >
                    <Check 
                      className={cn(
                        "text-green-500 w-3 h-3 absolute top-0 left-0 right-0 bottom-0 m-auto z-20",
                        disputeForm.Processing !== opt.value && "hidden"
                       )} />
                  </div>
                  <label>{opt.label}</label>
                </div>
              ))}

            </div>
          </div>  */}
        </div>
      </Form>
    </div>
  )
}